export enum DefaultProjectLoadState {
    NotStarted = 'NotStarted',
    Creating = 'Creating',
    SuccessCreateNew = 'SuccessCreateNew',
    ErrorCreateNew = 'ErrorCreateNew',
    SuccessLoadExisting = 'SuccessLoadExisting',
    ErrorLoadExisting = 'ErrorLoadExisting',
    SuccessDeleteExisting = 'SuccessDeleteExisting',
}
